export type NumberType = 'Local' | 'Mobile' | 'TollFree'

export type CountryOptions = {
    code: string,
    name: string,
    defaultNumberType?: NumberType,
  }
  
export const defaultCountryOptions: CountryOptions[] = [
    { code: '+1', name: 'United States' },
    { code: '+1', name: 'Canada' },
]
  
  
export function format_number(number: string | undefined | null): string {
    if (!number) return ''
    // may have country code...
    // get number in raw digits and then format
    number = number.replace(/\D/g, '')
    // format number
    if (number.length === 10) {
        number = `(${number.slice(0, 3)}) ${number.slice(3, 6)}-${number.slice(6)}`
    } else if (number.length === 11) {
        number = `+${number.slice(0, 1)} (${number.slice(1, 4)}) ${number.slice(4, 7)}-${number.slice(7)}`
    } else if (number.length === 12 && number.startsWith('49')) {
        // German number format: +49 XXX XXXXXXX
        number = `+${number.slice(0, 2)} ${number.slice(2, 5)} ${number.slice(5)}`
    } else if (number.length === 13 && number.startsWith('49')) {
        // German number format: +49 XXX XXXXXXXX
        number = `+${number.slice(0, 2)} ${number.slice(2, 5)} ${number.slice(5)}`
    }
    return number
}
